export enum VehicleTypeEnum {
  Car = 1,
  Truck = 2,
  Motocycle = 3,
  FarmMachine = 4,
  RoadImplement = 5,
}

export enum DataTableModelEnum {
  Model = 0,
  FamilyVersion = 1,
  Family = 2,
  FamilyGroup = 3,
}

export enum DataTableDncEnum {
  DncFamily = 0,
  DncFamilyGroup = 1,
}

export const VehicleTypeName = {
  [VehicleTypeEnum.Car]: () => 'Automóvel e Comercial Leve',
  [VehicleTypeEnum.Truck]: () => 'Caminhão e Ônibus',
  [VehicleTypeEnum.Motocycle]: () => 'Motocicleta',
  [VehicleTypeEnum.FarmMachine]: () => 'Máquina Agrícola',
  [VehicleTypeEnum.RoadImplement]: () => 'Implemento Rodoviário',
};

export const VehicleTypeInitials: any = {
  [VehicleTypeEnum.Car]: 'A',
  [VehicleTypeEnum.Truck]: 'C',
  [VehicleTypeEnum.Motocycle]: 'M',
  [VehicleTypeEnum.FarmMachine]: 'MA',
  [VehicleTypeEnum.RoadImplement]: 'IR',
};

export const Unknown = -1;

export enum FamilyExpressOptionEnum {
  Anothers = 1,
  NotApplicable = 2,
  CloneFamily = 3,
}

export enum EditFamilyTypeEnum {
  Family = 1,
  FamilyVersion = 2,
  FamilyGroup = 3,
}
